module.exports = __webpack_public_path__ + "img/br26.206e5d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br26.jpg
// module id = rjIm
// module chunks = 0